import {
    DeviceSettingsGeneralConfigurationFormValidation,
    DeviceSettingsGeneralConfigurationFormValidationKeys,
} from './configuration-status-tracking.validation.type';

export const areSectionsValidExcept = (
    formValidation: DeviceSettingsGeneralConfigurationFormValidation,
    excludedKey: DeviceSettingsGeneralConfigurationFormValidationKeys
): boolean =>
    Object.entries(formValidation).every(([key, validity]) => key === excludedKey || validity.state === 'valid');
